import { render, staticRenderFns } from "./genare-code.vue?vue&type=template&id=92c7da6a&scoped=true"
import script from "./genare-code.vue?vue&type=script&lang=js"
export * from "./genare-code.vue?vue&type=script&lang=js"
import style0 from "./genare-code.vue?vue&type=style&index=0&id=92c7da6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c7da6a",
  null
  
)

export default component.exports